/* LdapConfigRenderer.js */

"use strict";
const _ = require("lodash");
//const Steve = (require("@gluenetworks/steve_core")).getInstance();
const uiCore = require("@gluenetworks/steve_ui_core");
const ButtonControl = uiCore.Control.Action.Button;
const InputTextControl = uiCore.Control.Textfield.InputText;
const TextAreaControl = uiCore.Control.Textfield.Textarea;
const InputNumberControl = uiCore.Control.Textfield.InputNumber;
const CheckboxControl = uiCore.Control.Boolean.InputCheckbox;
const ComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;
const MultiCombobox = uiCore.Control.OptionSelection.Multiple.ComboBox;
const InputRadioControl = uiCore.Control.OptionSelection.Single.InputRadio;

class LdapConfigRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("ldap-config-gl"); //TODO Setup the root Element
        this._rootElem.component = this._model;
        this._ldapContainer = document.createElement("div");
        this._testButton = new ButtonControl({
            id: "test-ldap",
            label: "Test LDAP Connection",
            title: "Test the LDAP configuration and connection",
            disabled: false,
        });
        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._model.on(
            "ActionGroupsFeedUpdated",
            (this._updateRoles = this._updateRoles.bind(this))
        );
        this._model.on(
            "enableLDAP",
            (this._onLdapEnableChange = this._onLdapEnableChange.bind(this))
        );
        this._testButton.on(
            "UserClick",
            (this._onTestLdapClicked = this._onTestLdapClicked.bind(this))
        );
    }

    _unregisterListeners() {
        this._model.removeAllListeners("ActionGroupsFeedUpdated");
        this._model.removeListener("enableLDAP", this._onLdapEnableChange);
        this._testButton.removeListener("UserClick", this._onTestLdapClicked);
        this._unregisterLDAPListeners();
    }

    _registerLDAPListeners() {
        this._ldapDefaultActionGroupId.on(
            "UserValue",
            this._gatherLdapDataAndUpdateModel.bind(this)
        );
        this._mapActionGroupsCheckbox.on("UserValue", this._onMapActionGroupsChange.bind(this));
        this._ldapSomeOrgVisibility.on("UserValue", this._onSomeOrgVisChanged.bind(this));
        this._ldapOrgVisibility.on("UserValue", this._orgVisChanged.bind(this));
        Object.keys(this._ldapControls).forEach((ldapPropName) => {
            if (ldapPropName === "mapping") {
                Object.keys(this._ldapControls.mapping).forEach((mapProp) => {
                    if (mapProp === "actionGroupMapping") {
                        Object.keys(this._ldapControls.mapping.actionGroupMapping).forEach(
                            (authMapProp) => {
                                this._ldapControls.mapping.actionGroupMapping[authMapProp].on(
                                    "UserValue",
                                    this._gatherLdapDataAndUpdateModel.bind(this)
                                );
                            }
                        );
                    } else {
                        this._ldapControls.mapping[mapProp].on(
                            "UserValue",
                            this._gatherLdapDataAndUpdateModel.bind(this)
                        );
                    }
                });
            } else {
                this._ldapControls[ldapPropName].on(
                    "UserValue",
                    this._gatherLdapDataAndUpdateModel.bind(this)
                );
            }
        });
    }

    _unregisterLDAPListeners() {
        if (this._ldapContainer.firstChild) {
            this._ldapDefaultActionGroupId.removeListener(
                "UserValue",
                this._gatherLdapDataAndUpdateModel
            );
            this._mapActionGroupsCheckbox.removeListener(
                "UserValue",
                this._onMapActionGroupsChange
            );
            this._ldapSomeOrgVisibility.removeListener("UserValue", this._onSomeOrgVisChanged);
            this._ldapOrgVisibility.removeListener("UserValue", this._orgVisChanged);
            Object.keys(this._ldapControls).forEach((ldapPropName) => {
                if (ldapPropName === "mapping") {
                    Object.keys(this._ldapControls.mapping).forEach((mapProp) => {
                        if (mapProp === "actionGroupMapping") {
                            Object.keys(this._ldapControls.mapping.actionGroupMapping).forEach(
                                (authMapProp) => {
                                    this._ldapControls.mapping.actionGroupMapping[
                                        authMapProp
                                    ].removeListener(
                                        "UserValue",
                                        this._gatherLdapDataAndUpdateModel
                                    );
                                }
                            );
                        } else {
                            this._ldapControls.mapping[mapProp].removeListener(
                                "UserValue",
                                this._gatherLdapDataAndUpdateModel
                            );
                        }
                    });
                } else {
                    this._ldapControls[ldapPropName].removeListener(
                        "UserValue",
                        this._gatherLdapDataAndUpdateModel
                    );
                }
            });
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        let promArr = [this._testButton.shutdown()];

        return Promise.all(promArr).then(
            () => {
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                if (this._ldapContainer.firstChild) {
                    _.forEach(this._ldapControls, (control, controlName) => {
                        if (controlName === "mapping") {
                            _.forEach(control, (mappingControl, mappingControlName) => {
                                if (mappingControlName === "actionGroupMapping") {
                                    _.forEach(mappingControl, (authControl) => {
                                        authControl.shutdown();
                                    });
                                } else {
                                    mappingControl.shutdown();
                                }
                            });
                        } else {
                            control.shutdown();
                        }
                    });
                    this._ldapControls = undefined;
                    this._ldapContainer.remove();
                    this._ldapContainer = undefined;
                    this._testButton.shutdown();
                    this._testButton = undefined;
                    this._ldapControls = undefined;
                    this._actionGroupMapElem.remove();
                    this._actionGroupMapElem = undefined;
                    this._ldapOrgVisibility.shutdown();
                    this._ldapOrgVisibility = undefined;
                    this._ldapSomeOrgVisibility.shutdown();
                    this._ldapSomeOrgVisibility = undefined;
                    this._mapActionGroupsCheckbox.shutdown();
                    this._mapActionGroupsCheckbox = undefined;
                    this._ldapDefaultActionGroupId.shutdown();
                    this._ldapDefaultActionGroupId = undefined;
                }
            },
            (err) => {
                console.error(err);
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return this.model.whenModelIsReady().then(() => {
            this._onLdapEnableChange(this.model._isEnabled, true);
            Promise.resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    _renderPair(labelName, component, container, indent, title = "") {
        let labelElem = document.createElement("label");
        labelElem.innerText = labelName;
        labelElem.classList.add("form-label-gl");
        let cmpntElem = component.renderer.getRootElement();

        if (indent) {
            labelElem.classList.add("indented-gl");
            cmpntElem.classList.add("indented-gl");
        }

        if (title) {
            labelElem.title = title;
        }

        container.appendChild(labelElem);
        container.appendChild(cmpntElem);
    }

    _getActionGroups() {
        if (this._model._isProvider && this.model.actionGroupsFeed) {
            return this.model.actionGroupsFeed.filter((role) => {
                if (role.systemInternal || role.seeded || (role.enabled && role.shared)) {
                    return true;
                }
                return false;
            });
        } else {
            return this.model.actionGroupsFeed.filter((role) => {
                if (!role.systemInternal) {
                    return true;
                }
                return false;
            });
        }
    }

    _renderRoles() {
        if (!this.model.actionGroupsFeed || !this._ldapControls) {
            return Promise.resolve();
        }
        const roles = this._getActionGroups();

        this._actionGroupMapElem.innerHTML = "";
        roles.forEach((actionGroupProp) => {
            //.getCacheAsArray()
            try {
                let actionGroupMapInputControl = new InputTextControl({darkTheme: true});
                this._ldapControls.mapping.actionGroupMapping[actionGroupProp.id] =
                    actionGroupMapInputControl;
                this._renderPair(
                    actionGroupProp.name,
                    actionGroupMapInputControl,
                    this._actionGroupMapElem,
                    true
                );
            } catch (err) {
                return Promise.reject(err);
            }
        });

        return Promise.resolve();
    }

    _renderLdapFields() {
        if (!this._ldapContainer.firstChild) {
            this._ldapControls = {};
            this._ldapControls.userDomain = new InputTextControl({darkTheme: true});
            this._renderPair(
                "LDAP Domain*",
                this._ldapControls.userDomain,
                this._ldapContainer,
                false,
                "The domain name users include when signing in. Enter * if domain name not required"
            );

            this._ldapControls.stripDomain = new CheckboxControl({
                darkTheme: true,
                labelShown: true,
                label: "Send username to LDAP server without domain",
                title: "Strips domain name off the username",
            });
            this._ldapControls.stripDomain.renderer.rootElement.classList.add("form-label-gl");
            this._ldapContainer.appendChild(this._ldapControls.stripDomain.renderer.rootElement);
            this._ldapControls.ldapUsersOnly = new CheckboxControl({
                darkTheme: true,
                labelShown: true,
                label: "Disable creation of local users",
                title: "Limits new users to only those in LDAP",
            });
            this._ldapControls.ldapUsersOnly.renderer.rootElement.classList.add("form-label-gl");
            this._ldapContainer.appendChild(this._ldapControls.ldapUsersOnly.renderer.rootElement);
            this._ldapControls.host = new InputTextControl({darkTheme: true});
            this._renderPair(
                "Host*",
                this._ldapControls.host,
                this._ldapContainer,
                false,
                "Host name or IP address of the LDAP server"
            );
            this._ldapControls.port = new InputNumberControl({darkTheme: true, value: 389});
            this._renderPair(
                "Port*",
                this._ldapControls.port,
                this._ldapContainer,
                false,
                "Port of the LDAP server: 389 or 636 (SSL)"
            );
            this._ldapControls.adminDn = new InputTextControl({darkTheme: true});
            this._renderPair(
                "Admin Distinguished Username*",
                this._ldapControls.adminDn,
                this._ldapContainer,
                false,
                "Username used to search for user entries"
            );
            this._ldapControls.adminPassword = new ComboBoxControl({darkTheme: true});
            this._ldapControls.adminPassword.setOptions(this._model._credentialsList);
            this._renderPair(
                "Admin User Password Credential*",
                this._ldapControls.adminPassword,
                this._ldapContainer,
                false,
                "Password used to bind to the Admin Distinguished Username"
            );
            this._ldapControls.baseDn = new InputTextControl({darkTheme: true});
            this._renderPair(
                "Base Distinguished Name*",
                this._ldapControls.baseDn,
                this._ldapContainer,
                false,
                "Location where the server will look for user accounts"
            );

            this._ldapControls.userNameAttr = new InputTextControl({darkTheme: true});
            this._renderPair(
                "Username Attribute*",
                this._ldapControls.userNameAttr,
                this._ldapContainer,
                false,
                "LDAP attribute where the username is stored in a user entry"
            );
            this._ldapControls.userFilter = new InputTextControl({darkTheme: true});
            this._ldapContainer.appendChild(this._testButton.renderer.rootElement);
            this._renderPair(
                "LDAP user filter (Optional)",
                this._ldapControls.userFilter,
                this._ldapContainer,
                false,
                "Optional LDAP filter applied when searching for a user entry"
            );
            this._ldapControls.ssl = new CheckboxControl({
                darkTheme: true,
                labelShown: true,
                label: "Use SSL",
                title: "Select if you are using LDAPS",
            });
            this._ldapControls.ssl.renderer.rootElement.classList.add("form-label-gl");
            this._ldapContainer.appendChild(this._ldapControls.ssl.renderer.rootElement);
            this._ldapControls.skipIdentityCheck = new CheckboxControl({
                darkTheme: true,
                labelShown: true,
                label: "Skip server identity check",
                title: "Accepts any certificate offered to Gluware",
            });
            this._ldapControls.skipIdentityCheck.renderer.rootElement.classList.add(
                "form-label-gl"
            );
            this._ldapContainer.appendChild(
                this._ldapControls.skipIdentityCheck.renderer.rootElement
            );
            this._ldapControls.tlsCert = new TextAreaControl({darkTheme: true});
            this._renderPair(
                "Certificate (Required for SSL or StartTLS)",
                this._ldapControls.tlsCert,
                this._ldapContainer,
                false,
                "The certificate for the LDAP server"
            );
            this._ldapControls.mapping = {};
            this._ldapControls.mapping.email = new InputTextControl({darkTheme: true});
            this._renderPair(
                "Custom Email Attribute",
                this._ldapControls.mapping.email,
                this._ldapContainer,
                false,
                "Attribute that contains user's email address"
            );
            this._ldapControls.mapping.first = new InputTextControl({darkTheme: true});
            this._renderPair(
                "Custom First Name Attribute",
                this._ldapControls.mapping.first,
                this._ldapContainer,
                false,
                "Attribute that contains user’s first name"
            );
            this._ldapControls.mapping.last = new InputTextControl({darkTheme: true});
            this._renderPair(
                "Custom Last Name Attribute",
                this._ldapControls.mapping.last,
                this._ldapContainer,
                false,
                "Attribute that contains user’s last name"
            );

            this._ldapControls.mapping.actionGroup = new InputTextControl({darkTheme: true});
            this._renderPair(
                "Role Attribute",
                this._ldapControls.mapping.actionGroup,
                this._ldapContainer,
                false,
                "Attribute that contains user's Gluware role"
            );

            this._mapActionGroupsCheckbox = new CheckboxControl({
                darkTheme: true,
                labelShown: true,
                label: "Map Role Attribute Value",
                title: "Create up to five LDAP security groups mapped to Gluware roles",
            });
            this._ldapContainer.appendChild(this._mapActionGroupsCheckbox.renderer.rootElement);
            this._mapActionGroupsCheckbox.renderer.rootElement.classList.add("form-label-gl");

            this._ldapControls.mapping.actionGroupMapping = {};
            this._actionGroupMapElem = document.createElement("action-auth-map-elem");
            this._renderRoles();
            this._ldapContainer.appendChild(this._actionGroupMapElem);
            this._actionGroupMapElem.classList.add("hidden");

            this._ldapDefaultActionGroupId = new ComboBoxControl({darkTheme: true});
            this._renderPair(
                "Default Role",
                this._ldapDefaultActionGroupId,
                this._ldapContainer,
                false,
                "Default role given if no role attribute defined"
            );

            this._ldapControls.mapping.orgVisibility = new InputTextControl({darkTheme: true});
            this._renderPair(
                "Organization Visibility Attribute",
                this._ldapControls.mapping.orgVisibility,
                this._ldapContainer,
                false,
                "Attribute that contains a string of organization names the user can access"
            );
            this._ldapOrgVisibility = new InputRadioControl({
                darkTheme: true,
                horizontal: true,
                options: [
                    {label: "All", value: "All"},
                    {label: "Some", value: "Some"},
                    {label: "Home Organization", value: "Home"},
                ],
                value: "Home",
            });
            this._renderPair(
                "Default Organization Visibility",
                this._ldapOrgVisibility,
                this._ldapContainer,
                false,
                "Organization access given if no visibility attribute defined"
            );

            this._ldapSomeOrgVisibility = new MultiCombobox({darkTheme: true});

            this._ldapContainer.appendChild(this._ldapSomeOrgVisibility.renderer.rootElement);
            this.rootElement.appendChild(this._ldapContainer);
            this._registerLDAPListeners();

            this.setLdapDataFromModel();
        }
    }

    _getLdapDataFromFields() {
        let LDAPConfig = {};
        Object.keys(this._ldapControls).forEach((ldapPropName) => {
            if (ldapPropName === "mapping") {
                Object.keys(this._ldapControls.mapping).forEach((mapProp) => {
                    if (mapProp === "actionGroupMapping") {
                        if (this._mapActionGroupsCheckbox.value) {
                            _.forEach(
                                this._ldapControls.mapping.actionGroupMapping,
                                (authControl, authProp) => {
                                    if (authControl.length > 0) {
                                        _.set(
                                            LDAPConfig,
                                            `mapping.actionGroupMapping.${authProp}`,
                                            authControl
                                        );
                                    }
                                }
                            );
                        }
                    } else {
                        let controlValue = this._ldapControls.mapping[mapProp];
                        let mapPropName = "mapping." + mapProp;
                        if (controlValue.length > 0) {
                            _.set(LDAPConfig, mapPropName, controlValue);
                        }
                    }
                });
            } else {
                let controlValue = this._ldapControls[ldapPropName].value;
                if (!_.isUndefined(controlValue)) {
                    if (!_.isString(controlValue)) {
                        LDAPConfig[ldapPropName] = this._ldapControls[ldapPropName].value;
                    } else {
                        if (controlValue.length > 0) {
                            LDAPConfig[ldapPropName] = this._ldapControls[ldapPropName].value;
                        }
                    }
                }
            }
        });

        _.assign(LDAPConfig, this._getDefaultOrgVisibility());
        _.assign(LDAPConfig, this._getActionGroupProp());

        let mappings = this._getMappingProps();
        if (mappings) {
            LDAPConfig.mapping = mappings;
        }

        return LDAPConfig;
    }

    _gatherLdapDataAndUpdateModel() {
        let LDAPConfig = this._getLdapDataFromFields();
        this.model.setSaveModel(LDAPConfig);
    }

    _getMappingProps() {
        let mappings = {};
        Object.keys(this._ldapControls.mapping).forEach((ldapPropName) => {
            if (ldapPropName === "actionGroupMapping") {
                if (this._mapActionGroupsCheckbox.value) {
                    Object.keys(this._ldapControls.mapping.actionGroupMapping).forEach(
                        (actionGroupPropName) => {
                            let value =
                                this._ldapControls.mapping.actionGroupMapping[actionGroupPropName]
                                    .value;
                            if (_.isString(value) && value.length > 0) {
                                _.set(mappings, `actionGroupMapping.${actionGroupPropName}`, value);
                            }
                        }
                    );
                }
            } else {
                let value = this._ldapControls.mapping[ldapPropName].value;
                if (_.isString(value) && value.length > 0) {
                    mappings[ldapPropName] = value;
                }
            }
        });
        if (!_.isEmpty(mappings)) {
            return mappings;
        } else {
            return undefined;
        }
    }

    _getDefaultOrgVisibility() {
        let returnVal = {};
        if (this._ldapOrgVisibility.value === "Some") {
            returnVal = {};
            this._ldapSomeOrgVisibility.value.forEach((orgId) => {
                returnVal[orgId] = {};
            });
        } else {
            returnVal = this._ldapOrgVisibility.value;
        }
        if (_.isEmpty(returnVal)) {
            return undefined;
        }
        return {defaultOrgVisibility: returnVal};
    }

    _buildActionGroupList() {
        let actionGroupOptions = [];
        const actionGroups = this._getActionGroups();
        if (!_.isEmpty(actionGroups)) {
            Object.keys(actionGroups).forEach((groupKey) => {
                if (!actionGroups[groupKey].getSystemInternal()) {
                    const name = actionGroups[groupKey].name;
                    const agUUID = actionGroups[groupKey].id;
                    actionGroupOptions.push({label: name, value: agUUID});
                }
            });
        }
        return actionGroupOptions;
    }

    _getActionGroupProp() {
        if (this._ldapDefaultActionGroupId.getValue()) {
            return {defaultActionGroupId: this._ldapDefaultActionGroupId.getValue()};
        }
        return {};
    }

    _setDefaultOrgVisValue(allOrHomeorSome) {
        if (allOrHomeorSome === "Some") {
            let orgApiList = [];
            this._ldapSomeOrgVisibility.visible = true;
            Object.keys(this.model.userInfo.authorizedOrganizations).forEach((orgId) => {
                let orgName = this.model.userInfo.authorizedOrganizations[orgId].name;
                orgApiList.push({label: orgName, value: orgId});
            });
            this._ldapSomeOrgVisibility.setOptions(orgApiList);
            let selectedOrgsObj = _.get(
                this.model.selectedOrgInfo,
                "ldap.defaultOrgVisibility",
                false
            );
            if (_.isPlainObject(selectedOrgsObj)) {
                this._ldapSomeOrgVisibility.value = Object.keys(selectedOrgsObj);
            }
        } else {
            this._ldapSomeOrgVisibility.visible = false;
            this._ldapSomeOrgVisibility.setOptions([]);
        }
    }

    _setDefaultOrgVisValueFromModelValue() {
        let modelValue = _.get(this.model.selectedOrgInfo, "ldap.defaultOrgVisibility", "All");
        let allOrHomeorSome;
        if (_.isString(modelValue)) {
            allOrHomeorSome = modelValue;
        } else if (_.isPlainObject(modelValue)) {
            allOrHomeorSome = "Some";
        }
        this._ldapOrgVisibility.value = allOrHomeorSome;
        this._setDefaultOrgVisValue(allOrHomeorSome);
    }

    setLdapDataFromModel() {
        //Re-applied on every render so the list tracks the selected org. Must run before the
        //_setControlValue loop below, which assigns the selected credential.
        this._ldapControls.adminPassword.setOptions(this._model._credentialsList || []);
        this._ldapDefaultActionGroupId.setOptions(this._buildActionGroupList());
        this._ldapDefaultActionGroupId.setValue(
            _.get(this.model.selectedOrgInfo, "ldap.defaultActionGroupId")
        );
        //Organization Visibility
        this._setDefaultOrgVisValueFromModelValue();
        let haveActionGroupMappings = _.get(
            this.model.selectedOrgInfo,
            "ldap.mapping.actionGroupMapping"
        );
        this._mapActionGroupsCheckbox.setValue(haveActionGroupMappings);
        this._showHideActionGroupMap();
        Object.keys(this._ldapControls).forEach((ldapPropName) => {
            if (ldapPropName === "mapping") {
                Object.keys(this._ldapControls.mapping).forEach((mapProp) => {
                    if (mapProp === "actionGroupMapping") {
                        if (haveActionGroupMappings) {
                            Object.keys(this._ldapControls.mapping.actionGroupMapping).forEach(
                                (authMapProp) => {
                                    this._setControlValue(
                                        "mapping.actionGroupMapping." + authMapProp
                                    );
                                }
                            );
                        }
                    } else {
                        this._setControlValue("mapping." + mapProp);
                    }
                });
            } else {
                this._setControlValue(ldapPropName);
            }
        });
    }

    _setControlValue(ldapPropName) {
        if (!_.isUndefined(_.get(this.model.selectedOrgInfo, "ldap." + ldapPropName))) {
            _.set(
                this._ldapControls,
                ldapPropName + ".value",
                _.get(this.model.selectedOrgInfo, "ldap." + ldapPropName)
            );
        } else {
            _.set(this._ldapControls, ldapPropName + ".value", undefined);
        }
    }

    _hideLdapFields() {
        this._ldapContainer.style.display = "none";
    }

    _showLdapFields() {
        this._ldapContainer.style.display = "block";
    }

    _showHideActionGroupMap() {
        if (this._mapActionGroupsCheckbox.value) {
            this._actionGroupMapElem.classList.remove("hidden");
        } else {
            this._actionGroupMapElem.classList.add("hidden");
        }
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onTestLdapClicked() {
        this.model.emitTestLdap(this._getLdapDataFromFields());
    }

    _onLdapEnableChange(showLdapFields = true, refreshLdapData = false) {
        this._renderLdapFields();
        if (refreshLdapData) {
            this.setLdapDataFromModel();
        }
        if (showLdapFields) {
            this._showLdapFields();
            this._gatherLdapDataAndUpdateModel();
        } else {
            this._hideLdapFields();
            this.model.setSaveModel(undefined);
        }
    }

    _updateRoles() {
        if (this._ldapDefaultActionGroupId) {
            this._ldapDefaultActionGroupId.setOptions(this._buildActionGroupList());
        }
        return this._renderRoles();
    }

    _orgVisChanged(allOrHomeorSome) {
        this._setDefaultOrgVisValue(allOrHomeorSome);
        this._gatherLdapDataAndUpdateModel();
    }

    _onSomeOrgVisChanged() {
        this._gatherLdapDataAndUpdateModel();
    }

    _onMapActionGroupsChange() {
        this._showHideActionGroupMap();
        this._gatherLdapDataAndUpdateModel();
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/
    // TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}
module.exports = LdapConfigRenderer;
